export const HEADER_SEARCH = "HEADER_SEARCH";

export const postHeaderSearch = ({payload}) => {
  return {
    type: HEADER_SEARCH,
    payload:payload
  };
};